// import amazonPrimeSvg from '@/assets/icons/retailers/amazon-prime.svg'
// import walmartPlusSvg from '@/assets/icons/retailers/walmart-plus.svg'

import {Program} from '@/models/productModel'

// const PROGRAM_IMG: Record<Program, string> = {
//   [Program.WalmartPlus]: walmartPlusSvg,
//   [Program.AmazonPrime]: amazonPrimeSvg,
// }

// const PROGRAM_NAME: Record<Program, string> = {
//   [Program.WalmartPlus]: 'Walmart Plus',
//   [Program.AmazonPrime]: 'Amazon Prime',
// }

interface Props {
  program: Program | undefined
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- unused props
export default memo(function ProductProgramImage({program}: Props) {
  // NOTE: hide program images as requested from business
  // // eslint-disable-next-line security/detect-object-injection -- its safe
  // if (program && PROGRAM_IMG[program])
  //   // eslint-disable-next-line security/detect-object-injection -- its safe
  //   return <img src={PROGRAM_IMG[program]} alt={PROGRAM_NAME[program] + ' available'} loading='lazy' />
  return null
})
